// extracted by mini-css-extract-plugin
module.exports = {"h1":"styles_h1__fExJ8","h2":"styles_h2__Tg3_D","h3":"styles_h3__9Ovz5","h4":"styles_h4__w_8hF","h5":"styles_h5___Nq5r","h6":"styles_h6__2CRsV","bold":"styles_bold__iOoZj"};